import React, { useState, useEffect } from 'react';

import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField, Typography } from '@mui/material';

import AxlDialog from 'components/AxlDialog';

function DialogConfirm(props) {
  const { title, isOpen, onClose, isSubmitting, btnSubmit, color = 'primary', handleSubmit, showWarning = false } = props;
  const [remark, setRemark] = useState('');
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  // Reset state when dialog is closed
  useEffect(() => {
    if (!isOpen) {
      setRemark('');
      setShowConfirmDialog(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    if (!isSubmitting) {
      setRemark('');
      onClose();
    }
  };

  const handleSubmitClick = () => {
    // Show confirmation dialog before submitting
    setShowConfirmDialog(true);
  };

  const handleConfirmSubmit = () => {
    setShowConfirmDialog(false);
    handleSubmit(remark);
  };

  const handleCancelConfirm = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <AxlDialog
        maxWidth="sm"
        isOpen={isOpen}
        childrenTitle={title}
        handleClose={() => handleClose()}
        childrenAction={
          <Box sx={{ display: 'flex' }} style={{ gap: 8 }}>
            <Button disableElevation disabled={isSubmitting} onClick={() => handleClose()} color="inherit" variant="outlined" size="small">
              CANCEL
            </Button>
            <Button disableElevation disabled={!remark || isSubmitting} onClick={handleSubmitClick} color={color} variant="contained" size="small">
              {isSubmitting ? <CircularProgress size={20} color="inherit" /> : btnSubmit}
            </Button>
          </Box>
        }
      >
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              required
              autoFocus
              margin="dense"
              id="remark"
              name="remark"
              label="Type a message"
              fullWidth
              variant="outlined"
              minRows={3}
              multiline
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Grid>
          {showWarning && (
            <Grid size={12}>
              <Typography
                variant="body2"
                sx={{
                  color: '#ed6c02',
                  fontStyle: 'italic',
                }}
              >
                Warning: This action will notify the driver to resubmit their request
              </Typography>
            </Grid>
          )}
        </Grid>
      </AxlDialog>
      {/* Confirmation Dialog */}
      <Dialog open={showConfirmDialog} onClose={handleCancelConfirm} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Submission</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to submit this remark?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelConfirm} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleConfirmSubmit} color={color} variant="contained" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DialogConfirm;
